import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {isOutlookEnabled} from "../helpers";
import {createItem} from "../helpers/createItem";

// TODO add action for test purposes
// export const createEmail = (
//  agm: Glue42Core.AGM.API,
//  email?: EmailParams,
//  options?: NewEmailOptions,
//  action?: number):
// Promise<void> =>
export const createEmail = (
    agm: Glue42Core.AGM.API,
    email?: Glue42Office.Outlook.EmailParams,
    options?: Glue42Office.Outlook.NewEmailOptions): Promise<void> =>
    new Promise<void>((resolve, reject) => {
        if (!isOutlookEnabled(agm)) {
            reject(`The method "newEmail" is not available`);
            return;
        }

        // TODO add action for test purposes
        // return createItem(agm, email, "email", options, action)
        return createItem(agm, email, "email", options)
            .then(() => resolve())
            .catch(reject);
    });
